import { useTranslation } from "react-i18next";
import {
  formatLocal,
  weekdayOfLocal,
  getClientTimeZone,
  isClientOnBusinessTime
} from "../../services/business-time";

// Shown under the appointment and callback pickers: the time an agent enters
// is German time, whatever timezone the PC runs on. The summary repeats the
// selection with its weekday; the hint appears only on a PC that is not on
// German time.
const BusinessTimeInfo = ({ localDateTime }) => {
  const { t, i18n } = useTranslation();
  // React escapes the output; i18next must not escape the "/" of a zone name
  const interpolation = { escapeValue: false };
  return (
    <div className="mt-2">
      <div className="text-secondary small">
        {t("leadAgent.businessTimeLabel")}
      </div>
      {localDateTime && (
        <div className="fw-bold">
          {t("leadAgent.businessTimeSummary", {
            weekday: weekdayOfLocal(localDateTime, i18n.language),
            dateTime: formatLocal(localDateTime, "DD.MM.YYYY, HH:mm"),
            interpolation
          })}
        </div>
      )}
      {!isClientOnBusinessTime() && (
        <div className="alert alert-warning small py-2 px-3 mt-2 mb-0">
          {t("leadAgent.businessTimeHint", {
            zone: getClientTimeZone(),
            interpolation
          })}
        </div>
      )}
    </div>
  );
};

export default BusinessTimeInfo;
